import React from "react";
import ContentLoader from "react-content-loader";
import Heading from "components/Elements/Heading.js";

export const QueryBuilderSegmentsLoader = (props) => (
  <div className="row">
    <div className="col-10">
      <div className="row segmentation-table query-view-border query-builder-loader-container">
        <div className="col-2">
          {props.noData && (
            <div className="query-loader-no-data">
              <span className="speech-bubble">Oops!</span>
              <Heading size={4} className={"mt-3"}>
                Sorry, we don’t have any data for this query. <br />
                Try again with different options.
              </Heading>
            </div>
          )}
          <ContentLoader
            style={{ width: "100%" }}
            height={50}
            viewBox="0 0 200 45"
            backgroundColor="#ECECEC"
          >
            <rect x="0" y="0" rx="2" ry="2" width={"100%"} height="45" />
          </ContentLoader>

          <ContentLoader
            speed={3}
            style={{ width: "100%" }}
            viewBox="0 0 200 550"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
            <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
            <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
            <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
          </ContentLoader>
        </div>
        <div className="col-2">
          <ContentLoader
            style={{ width: "100%" }}
            height={50}
            viewBox="0 0 200 45"
            backgroundColor="#ECECEC"
          >
            <rect x="0" y="0" rx="2" ry="2" width={"100%"} height="45" />
          </ContentLoader>

          <ContentLoader
            speed={3}
            style={{ width: "100%" }}
            viewBox="0 0 200 550"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
            <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
            <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
            <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
          </ContentLoader>
        </div>
        <div className="col-8">
          <ContentLoader
            style={{ width: "100%" }}
            height={50}
            viewBox="0 0 650 38"
            backgroundColor="#ECECEC"
          >
            <rect x="0" y="2" rx="2" ry="2" width={"100%"} height="38" />
          </ContentLoader>
          <ContentLoader
            speed={3}
            style={{ width: "100%" }}
            viewBox="0 0 650 550"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
            <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
            <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
            <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
            <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
            <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
            <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
            <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
            <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
          </ContentLoader>
        </div>
      </div>
    </div>

    <div className="col-2">
      <div className="query-builder-loader-legend">
        <ContentLoader
          style={{ width: "100%" }}
          height={50}
          viewBox="0 0 200 45"
          backgroundColor="#ECECEC"
        >
          <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
        </ContentLoader>
        <ContentLoader
          speed={3}
          style={{ width: "100%" }}
          viewBox="0 0 200 350"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="5" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
          <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
          <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
          <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
          <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        </ContentLoader>
      </div>
    </div>
  </div>
);

export const QueryBuilderLineChartLoader = () => (
  <div className="row">
    <div className="col-10">
      <div className="row segmentation-table query-view-border query-builder-loader-container">
        <ContentLoader
          speed={3}
          style={{ width: "100%" }}
          viewBox="0 0 960 595"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="5" y="5" rx="3" ry="3" width="99%" height="595" />
        </ContentLoader>
      </div>
    </div>

    <div className="col-2">
      <div className="query-builder-loader-legend">
        <ContentLoader
          style={{ width: "100%" }}
          height={50}
          viewBox="0 0 200 45"
          backgroundColor="#ECECEC"
        >
          <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
        </ContentLoader>
        <ContentLoader
          speed={3}
          style={{ width: "100%" }}
          viewBox="0 0 200 350"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="5" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
          <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
          <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
          <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
          <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        </ContentLoader>
      </div>
    </div>
  </div>
);

export const QueryBuilderBarChartLoader = () => (
  <div className="row">
    <div className="col-10">
      <div className="row segmentation-table query-view-border query-builder-loader-container">
        <ContentLoader
          speed={3}
          style={{ width: "100%" }}
          viewBox="10 0 960 595"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="20" y="565" rx="3" ry="3" width="50" height="30" />
          <rect x="80" y="545" rx="3" ry="3" width="50" height="50" />
          <rect x="140" y="495" rx="3" ry="3" width="50" height="100" />
          <rect x="200" y="345" rx="3" ry="3" width="50" height="250" />
          <rect x="260" y="295" rx="3" ry="3" width="50" height="300" />
          <rect x="320" y="195" rx="3" ry="3" width="50" height="400" />
          <rect x="380" y="145" rx="3" ry="3" width="50" height="450" />
          <rect x="440" y="195" rx="3" ry="3" width="50" height="400" />
          <rect x="500" y="295" rx="3" ry="3" width="50" height="300" />
          <rect x="560" y="395" rx="3" ry="3" width="50" height="200" />
          <rect x="630" y="445" rx="3" ry="3" width="50" height="150" />
          <rect x="690" y="195" rx="3" ry="3" width="50" height="400" />
          <rect x="750" y="395" rx="3" ry="3" width="50" height="200" />
          <rect x="810" y="545" rx="3" ry="3" width="50" height="50" />
          <rect x="870" y="495" rx="3" ry="3" width="50" height="100" />
        </ContentLoader>
      </div>
    </div>

    <div className="col-2">
      <div className="query-builder-loader-legend">
        <ContentLoader
          style={{ width: "100%" }}
          height={50}
          viewBox="0 0 200 45"
          backgroundColor="#ECECEC"
        >
          <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
        </ContentLoader>
        <ContentLoader
          speed={3}
          style={{ width: "100%" }}
          viewBox="0 0 200 350"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="5" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
          <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
          <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
          <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
          <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
          <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        </ContentLoader>
      </div>
    </div>
  </div>
);

export const QueryBuilderTableLoader = () => (
  <div className="row segmentation-table query-view-border query-builder-loader-container">
    <div className="col-4">
      <ContentLoader
        style={{ width: "100%" }}
        height={50}
        viewBox="0 0 400 45"
        backgroundColor="#ECECEC"
      >
        <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
      </ContentLoader>
      <ContentLoader
        speed={3}
        style={{ width: "100%" }}
        viewBox="0 0 400 550"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
        <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
        <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
      </ContentLoader>
    </div>
    <div className="col-4">
      <ContentLoader
        style={{ width: "100%" }}
        height={50}
        viewBox="0 0 400 45"
        backgroundColor="#ECECEC"
      >
        <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
      </ContentLoader>
      <ContentLoader
        speed={3}
        style={{ width: "100%" }}
        viewBox="0 0 400 550"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
        <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
        <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
      </ContentLoader>
    </div>
    <div className="col-4">
      <ContentLoader
        style={{ width: "100%" }}
        height={50}
        viewBox="0 0 400 45"
        backgroundColor="#ECECEC"
      >
        <rect x="0" y="5" rx="2" ry="2" width={"100%"} height="45" />
      </ContentLoader>
      <ContentLoader
        speed={3}
        style={{ width: "100%" }}
        viewBox="0 0 400 550"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="10" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="40" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="70" rx="3" ry="3" width="40%" height="15" />
        <rect x="0" y="100" rx="3" ry="3" width="90%" height="15" />
        <rect x="0" y="130" rx="3" ry="3" width="20%" height="15" />
        <rect x="0" y="160" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="190" rx="3" ry="3" width="60%" height="15" />
        <rect x="0" y="220" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="250" rx="3" ry="3" width="30%" height="15" />
        <rect x="0" y="280" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="310" rx="3" ry="3" width="70%" height="15" />
        <rect x="0" y="340" rx="3" ry="3" width="80%" height="15" />
        <rect x="0" y="370" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="400" rx="3" ry="3" width="20%" height="15" />
      </ContentLoader>
    </div>
  </div>
);

export const QueryBuilderInsightsFeedLoader = () => (
  <ContentLoader
    speed={2}
    style={{ width: "100%" }}
    viewBox="0 0 980 300"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="2" ry="2" width="115" height="15" />
    <rect x="0" y="25" rx="3" ry="3" width="950" height="20" />
    <rect x="0" y="50" rx="3" ry="3" width="980" height="20" />
    <rect x="0" y="75" rx="3" ry="3" width="980" height="20" />
    <rect x="0" y="100" rx="3" ry="3" width="650" height="20" />

    <rect x="0" y="150" rx="2" ry="2" width="115" height="15" />
    <rect x="0" y="175" rx="3" ry="3" width="950" height="20" />
    <rect x="0" y="200" rx="3" ry="3" width="980" height="20" />
    <rect x="0" y="225" rx="3" ry="3" width="980" height="20" />
    <rect x="0" y="250" rx="3" ry="3" width="650" height="20" />
  </ContentLoader>
);
